import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CompanyOptInAcceptanceSummary } from '../../../domain-model/company-opt-in-acceptance-summary.class';
import { OptInAction } from '../../../message-models/optin-action.interface';
import { DOCUMENT } from '@angular/common';
import { IOptInModalInfo } from '../../../message-models/optin-modal-info.interface';
import { OptInModalInfo } from '../../../message-models/optin-modal-info.class';
import { CompanyOptInService } from '../../services/company-opt-in.service';
import { DecisionRequirement } from '../../../message-models/decision-requirement.enum';
import { AuthorizeService } from '../../../../api-authorization/authorize.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-opt-in-modal',
  templateUrl: './company-opt-in-modal.component.html',
  styleUrls: ['./company-opt-in-modal.component.scss']
})

export class CompanyOptInModalComponent implements OnInit {
  @Input() modalDetails: OptInModalInfo = new OptInModalInfo({} as IOptInModalInfo);
  @Input() companyOptInAcceptanceSummaries: CompanyOptInAcceptanceSummary[] = [];
  @Output() recordOptInActionsClicked: EventEmitter<OptInAction[]> = new EventEmitter<OptInAction[]>();
  showErrors: boolean = false;
  showIndividualError: boolean = false;
  currentIndex: number = null;
  mustVisitMessage: string = 'You must visit this page to review the information before continuing';

  constructor(
    public modalRef: DynamicDialogRef,
    @Inject(DOCUMENT) private document: Document,
    private companyOptInService: CompanyOptInService,
    private authorizeService: AuthorizeService,
    private router: Router) { }

  ngOnInit(): void {
    this.companyOptInAcceptanceSummaries.forEach(item => {
      if (item.decision === null) {
        item.decision = item.defaultOptInState;
      }
    })
  }

  goToLink(companyOptInAcceptanceSummary: CompanyOptInAcceptanceSummary) {
    this.recordOptInAction(companyOptInAcceptanceSummary, true, companyOptInAcceptanceSummary.decision);
    if (companyOptInAcceptanceSummary.optInUrl !== '') {
      if (companyOptInAcceptanceSummary.openOnSamePage) {
        this.document.location.href = companyOptInAcceptanceSummary.optInUrl;
      } else {
        window.open(companyOptInAcceptanceSummary.optInUrl, '_newtab');
      }
    }
  }

  recordOptInActions() {
    let anyErrors = false;
    this.companyOptInAcceptanceSummaries.forEach(optIn => {
      optIn.showMustVisit = (optIn.mustVisit && !optIn.isUrlVisited);
      optIn.showError = (optIn.decisionRequirement === DecisionRequirement.MandatoryYes && optIn.decision !== true)
        || (optIn.decisionRequirement === DecisionRequirement.MandatoryNo && optIn.decision !== false);
      if (optIn.showError || optIn.showMustVisit)
        anyErrors = true;
    });

    if (anyErrors)
      return;

    let optInActions: Array<OptInAction> = [];
    this.companyOptInAcceptanceSummaries.forEach(item => {
      let optInAction = {
        companyId: item.companyId,
        optInEntryId: item.optInEntryId,
        visited: item.visitedOn.dateTime !== '',
        decision: item.decision ?? item.defaultOptInState,
        isFinalAcceptance: true
      } as OptInAction;
      optInActions.push(optInAction);
    })
    this.companyOptInService.recordOptInActions(optInActions).subscribe(result => {
      if (result) {
        this.modalRef.close();
        this.recordOptInActionsClicked.emit(optInActions);
      }
    })
  }

  compareHtmlStrings(str1: string, str2: string) {
    let div1 = document.createElement("div");
    div1.innerHTML = str1;
    let div2 = document.createElement("div");
    div2.innerHTML = str2;
    if (div1.textContent.toUpperCase() > div2.textContent.toUpperCase()) {
      return 1;
    } else if (div1.textContent.toUpperCase() < div2.textContent.toUpperCase()) {
      return -1;
    }
    return 0;
  }

  recordOptInAction(companyOptInAcceptanceSummary: CompanyOptInAcceptanceSummary, visited: boolean, decision?: boolean, saveOnly?: boolean) {
    let optInAction = {
      companyId: companyOptInAcceptanceSummary.companyId,
      optInEntryId: companyOptInAcceptanceSummary.optInEntryId,
      visited: visited,
      decision: decision
    } as OptInAction;

    companyOptInAcceptanceSummary.decisionFinalised = true;

    this.companyOptInService.recordOptInAction(optInAction).subscribe(result => {
      if (!saveOnly && result) {
        let newCompanyAcceptance = new CompanyOptInAcceptanceSummary(result);
        newCompanyAcceptance.showMustVisit = true;
        newCompanyAcceptance.showError = (newCompanyAcceptance.decisionRequirement === DecisionRequirement.MandatoryYes && newCompanyAcceptance.decision !== true)
          || (newCompanyAcceptance.decisionRequirement === DecisionRequirement.MandatoryNo && newCompanyAcceptance.decision !== false);
        this.companyOptInAcceptanceSummaries = this.companyOptInAcceptanceSummaries.filter(d => d.optInEntryId !== newCompanyAcceptance.optInEntryId);
        this.companyOptInAcceptanceSummaries.push(newCompanyAcceptance);
        this.companyOptInAcceptanceSummaries.sort((a, b) => this.compareHtmlStrings(a.optInDescription, b.optInDescription));
      }
    })
  }

  onChangeToggled(companyOptInAcceptanceSummary: CompanyOptInAcceptanceSummary) {
    this.recordOptInAction(companyOptInAcceptanceSummary, companyOptInAcceptanceSummary.visitedOn.dateTime !== null, companyOptInAcceptanceSummary.decision, true);
    if (companyOptInAcceptanceSummary.mustVisit && companyOptInAcceptanceSummary.visitedOn.dateTime === null) {
      setTimeout(() => {
        companyOptInAcceptanceSummary.showMustVisit = true;
      }, 500);
    }
  }

  clicked(b: boolean) { }

  signOut() {
    this.authorizeService.signOut('App').then(result =>
      this.router.navigate(['/'])
    );
  }
}
